import { Link } from 'react-router-dom'

export const PolicyDe = () => {
    return (
        <>
            <p style={{ marginBottom: '0in' }}>
                Diese Datenschutzrichtlinie (diese "Richtlinie") gilt für die
                von SafeTravy Limited (das "Unternehmen", "wir", "uns" oder
                "unser") bereitgestellte Plattform (einschließlich aller
                anwendbaren mobilen Anwendungen und Websites, die für den
                Zugriff auf die Plattform verwendet werden) (zusammen die
                "Plattform"). Sie beschreibt, wie das Unternehmen
                personenbezogene Daten sammelt, verwendet und offenlegt, die wir
                von Nutzern der Plattform und von über die Plattform
                bereitgestellten Kontodiensten erhalten, und wie wir diese Daten
                verwenden und offenlegen. Für die Zwecke dieser Richtlinie
                bezieht sich der Begriff "personenbezogene Daten" auf
                Informationen, die von einem Nutzer bereitgestellt werden und
                aus denen die Identität dieses Nutzers direkt oder indirekt
                ermittelt werden kann.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Mit der Registrierung für die Plattform und deren Nutzung
                erklären Sie sich damit einverstanden, dass Ihre persönlichen
                Daten wie in dieser Richtlinie und den für die Plattform
                geltenden Allgemeinen Geschäftsbedingungen (der
                "Dienstleistungsvertrag") behandelt werden; hier verwendete
                Begriffe in Großbuchstaben haben dieselbe Bedeutung wie im
                Dienstleistungsvertrag. Diese Datenschutzrichtlinie ist ein
                integraler Bestandteil der
                <Link to='/terms'>
                    <span style={{ color: '#1155cc' }}>
                        {' '}
                        <u> Allgemeinen Geschäftsbedingungen von SafeTravy</u>
                    </span>
                </Link>
                .
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Welche Daten sammeln wir?</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                SafeTravy sammelt die folgenden Daten:
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Persönliche</b>Identifikationsdaten (Name, E-Mail-Adresse,
                Staatsangehörigkeit usw.)
            </p>
            <p style={{ marginBottom: '0in' }}>
                Kontaktinformationen (E-Mail Adresse)
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Technische</b>Informationen (Internetprotokoll (IP)-Adresse,
                Anmeldedaten, Browsertyp und -version, Zeitzoneneinstellung und
                Standort, Betriebssystem und Plattform sowie andere Technologien
                auf den Geräten, die Sie für den Zugriff auf unsere Websites,
                Produkte und Dienstleistungen verwenden)
            </p>
            <p style={{ marginBottom: '0in' }}>
                Profilinformationen (Benutzername und Passwort, Ihre Interessen,
                Vorlieben, Feedback und Umfrageantworten)
            </p>
            <p style={{ marginBottom: '0in' }}>
                Nutzungsdaten (z. B. wie Sie unsere Website, Produkte und
                Dienstleistungen nutzen)
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Marketing- und</b>Kommunikationsinformationen (Ihre
                Präferenzen für den Erhalt von Marketingmaterial von uns und
                Ihre Kommunikationspräferenzen)
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Aggregierte</b>Informationen (statistische oder demografische
                Daten). Zusammengefasste Daten können aus Ihren
                personenbezogenen Daten abgeleitet werden, gelten aber rechtlich
                nicht als personenbezogene Daten, da diese Daten weder direkt
                noch indirekt Ihre Identität offenbaren. Wir KÖNNEN zum Beispiel
                Ihre Nutzungsdaten zusammenfassen, um den Prozentsatz der Nutzer
                zu berechnen, die auf eine bestimmte Funktion der Website
                zugreifen. Wenn wir jedoch zusammengefasste Daten mit Ihren
                personenbezogenen Daten kombinieren oder verbinden, so dass sie
                Sie direkt oder indirekt identifizieren können, behandeln wir
                die kombinierten Daten als personenbezogene Daten, die in
                Übereinstimmung mit dieser Datenschutzrichtlinie verwendet
                werden)
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>
                    Wir erheben keine besonderen Kategorien personenbezogener
                    Daten{' '}
                </b>
                über Sie (dazu gehören Angaben zu Ihrer Ethnie, Ihren religiösen
                oder philosophischen Überzeugungen, Ihrem Sexualleben, Ihrer
                sexuellen Orientierung, Ihren politischen Ansichten, Ihrer
                Mitgliedschaft in einer Gewerkschaft, Informationen über Ihre
                Gesundheit sowie genetische und biometrische Daten). Auch
                sammeln wir keine Informationen über strafrechtliche
                Verurteilungen und Straftaten.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Wie sammeln wir Ihre Daten?</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Die meisten der von uns erfassten Daten werden SafeTravy direkt
                von Ihnen zur Verfügung gestellt. Wir sammeln Daten und
                verarbeiten Daten, wenn Sie:
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginLeft: '0.5in', marginBottom: '0in' }}>
                <br />
            </p>
            <ul>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Freiwillig eine Kundenumfrage ausfüllen oder auf einem
                        unserer Messageboards oder per E-Mail Feedback geben.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Sie können unsere Website über die Cookies Ihres
                        Browsers nutzen oder ansehen.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Kontaktieren Sie uns direkt über unsere Website, per
                        E-Mail, Telefon oder andere Kommunikationsmittel.
                    </p>
                </li>
            </ul>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                SafeTravy erhält Ihre Daten auch indirekt aus den folgenden
                Quellen:
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <ul>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Automatisierte Technologien oder Interaktionen: Wenn Sie
                        mit unserer Website, unseren Produkten und Diensten
                        interagieren, sammeln wir automatisch technische Daten
                        über Ihre Geräte, Browsing-Aktionen und Muster. Wir
                        sammeln diese personenbezogenen Daten mit Hilfe von
                        Cookies, Serverprotokollen und anderen ähnlichen
                        Technologien.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>Technische Daten von:</p>
                </li>
            </ul>
            <ul>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Analytik-Anbieter wie Google mit Sitz außerhalb der
                        Europäischen Union (EU).
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Hosting- und andere Dienstleistungsanbieter wie Amazon
                        mit Sitz außerhalb der EU.
                    </p>
                </li>
            </ul>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Wie wir Ihre Informationen verwenden</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                Wir verwenden Ihre Daten, einschließlich Ihrer persönlichen
                Daten, für die folgenden Zwecke:
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <ul>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Um Ihnen unsere Plattform zur Verfügung zu stellen, um
                        die Kommunikation auf der Plattform zu erleichtern, um
                        mit Ihnen über Ihre Nutzung unserer Plattform zu
                        kommunizieren, um Ihre Anfragen zu beantworten, um Ihre
                        Bestellungen auszuführen und für andere
                        Kundendienstzwecke;
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Um den Inhalt und die Informationen, die wir Ihnen
                        senden oder anzeigen, auf Sie zuzuschneiden, um eine
                        individuelle Standortanpassung und personalisierte Hilfe
                        und Anweisungen anzubieten und um Ihre Erfahrungen bei
                        der Nutzung unserer Plattform anderweitig zu
                        personalisieren;
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Um besser zu verstehen, wie Nutzer auf die Plattform
                        zugreifen und sie nutzen, sowohl auf aggregierter als
                        auch auf individueller Basis, um unsere Plattform zu
                        verbessern und auf die Wünsche und Vorlieben der Nutzer
                        zu reagieren, sowie für andere Forschungs- und
                        Analysezwecke;
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Für Marketing- und Werbezwecke. Wir können Ihre Daten,
                        wie z. B. Ihre E-Mail-Adresse oder Ihre bei uns
                        registrierte Kontaktnummer, verwenden, um Ihnen
                        Nachrichten und Newsletter, Sonderangebote und
                        Werbeaktionen zuzusenden, Verlosungen und Wettbewerbe
                        durchzuführen oder Sie anderweitig über Produkte oder
                        Informationen zu informieren, die Sie interessieren
                        könnten. Wir können die Informationen, die wir über Sie
                        erfahren, auch dazu verwenden, um unsere Plattform auf
                        Websites Dritter zu bewerben.
                    </p>
                </li>
            </ul>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Wie wir Ihre Informationen weitergeben</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <ul>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Verbundene Unternehmen. Wir können die Informationen,
                        die wir von Ihnen erfassen, an unsere verbundenen
                        Unternehmen oder Tochtergesellschaften weitergeben, und
                        zwar ausschließlich zu dem Zweck, Ihnen die Plattform
                        oder damit verbundene Dienste, einschließlich
                        Untersite-Dienste, zur Verfügung zu stellen; wenn wir
                        dies jedoch tun, wird die Nutzung und Weitergabe Ihrer
                        personenbezogenen Daten durch diese verbundenen
                        Unternehmen und Tochtergesellschaften in Übereinstimmung
                        mit dieser Richtlinie erfolgen.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Dienstanbieter. Wir können die von Ihnen gesammelten
                        Informationen an Drittanbieter, Dienstleister,
                        Auftragnehmer oder Vertreter weitergeben, die in unserem
                        Auftrag Funktionen ausführen, vorausgesetzt, diese
                        Dritten haben zugestimmt, diese Informationen nur zur
                        Erbringung von Dienstleistungen für uns zu verwenden.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Geschäftsübertragungen. Wenn wir in Verhandlungen mit
                        einem anderen Unternehmen oder einer anderen
                        Körperschaft stehen, von einem anderen Unternehmen oder
                        einer anderen Körperschaft übernommen werden oder mit
                        einem anderen Unternehmen oder einer anderen
                        Körperschaft fusionieren, wenn im Wesentlichen alle
                        unsere Vermögenswerte auf ein anderes Unternehmen oder
                        eine andere Körperschaft übertragen werden oder als Teil
                        eines Konkursverfahrens, können wir die von Ihnen
                        erfassten Daten an das andere Unternehmen oder die
                        andere Körperschaft übertragen.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        In Reaktion auf rechtliche Verfahren. Wir können die von
                        Ihnen erfassten Informationen auch offenlegen, um dem
                        Gesetz, einem Gerichtsverfahren, einem Gerichtsbeschluss
                        oder einem anderen rechtlichen Verfahren nachzukommen,
                        z. B. als Antwort auf eine Vorladung.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Zum Schutz von uns und anderen. Wir können die von Ihnen
                        erfassten Informationen auch offenlegen, wenn wir
                        glauben, dass dies notwendig ist, um illegale
                        Aktivitäten, mutmaßlichen Betrug, Situationen, die eine
                        potenzielle Bedrohung für die Sicherheit von Personen
                        darstellen, Verstöße gegen unsere
                        Dienstleistungsvereinbarung oder diese Richtlinie zu
                        untersuchen, zu verhindern oder Maßnahmen zu ergreifen,
                        oder als Beweismittel in Rechtsstreitigkeiten, an denen
                        wir beteiligt sind.
                    </p>
                </li>
                <li>
                    <p style={{ marginBottom: '0in' }}>
                        Zusammengefasste und de-identifizierte Informationen.
                        Wir können zusammengefasste oder nicht identifizierte
                        Informationen über Nutzer sammeln, verarbeiten,
                        analysieren und mit Dritten und der Öffentlichkeit zu
                        Zwecken der Produktentwicklung, des Marketings, der
                        Werbung, der Forschung oder ähnlichen Zwecken teilen.
                    </p>
                </li>
            </ul>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Recht auf Zugang, Berichtigung und Löschung</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                Sie können jederzeit auf Ihr Konto oder die von uns erfassten
                persönlichen Daten zugreifen, sie bearbeiten, aktualisieren oder
                löschen, indem Sie auf Ihre Kontoeinstellungen zugreifen oder
                uns eine E-Mail an{' '}
                <span style={{ fontSize: '11pt' }}>safetravy@gmail.com </span>
                schicken. Wir werden Ihre Anfragen innerhalb eines angemessenen
                Zeitraums beantworten, spätestens jedoch innerhalb des
                gesetzlich vorgeschriebenen Zeitraums.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Bitte beachten Sie, dass wir unter bestimmten Umständen nicht in
                der Lage sind, einer Anfrage zur Bearbeitung, Aktualisierung,
                zum Zugriff oder zur Löschung eines Kontoprofils oder
                persönlicher Daten nachzukommen. Dies schließt ein, ist aber
                nicht beschränkt auf:
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                -jede Grundlage, auf der ein solcher Antrag nach geltendem Recht
                abgelehnt werden kann;
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                -Wenn wir die Informationen aufbewahren müssen, um Bundes-,
                Landes- oder lokale Gesetze einzuhalten oder für Buchhaltungs-
                oder Steuerzwecke;
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                wenn wir einer zivil-, strafrechtlichen oder behördlichen
                Anfrage, Untersuchung, Vorladung oder Vorladung durch Bundes-,
                Landes- oder Kommunalbehörden nachkommen müssen;
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                -wenn wir mit den Strafverfolgungsbehörden zusammenarbeiten
                müssen, weil das Unternehmen, der Dienstleister oder ein Dritter
                in gutem Glauben davon ausgeht, dass die Daten gegen Bundes-,
                Landes- oder lokale Gesetze verstoßen;
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                -wenn wir Informationen aufbewahren müssen, um rechtliche
                Ansprüche geltend zu machen oder zu verteidigen;
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                -wenn die Informationen ein gesetzliches Privileg oder
                geschützte Informationen einer anderen Partei enthalten; oder -
                wenn die Befolgung des Ersuchens die Privatsphäre oder andere
                legitime Rechte anderer beeinträchtigen würde.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                Wenn wir feststellen, dass wir eine Anfrage in einem bestimmten
                Fall nicht beantworten können, teilen wir Ihnen die Gründe für
                diese Entscheidung mit und nennen Ihnen eine Kontaktstelle für
                eventuelle Rückfragen. Um Ihre Privatsphäre zu schützen, werden
                wir wirtschaftlich angemessene Schritte unternehmen, um Ihre
                Identität zu überprüfen, bevor wir auf eine Anfrage im Rahmen
                dieser Bestimmung antworten, einschließlich der Einhaltung aller
                geltenden gesetzlichen Anforderungen zur Überprüfung Ihrer
                Identität.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Übermittlung von Informationen</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                Bitte beachten Sie, dass wir Ihre personenbezogenen Daten auf
                Servern in einem Drittland speichern können. Wenn sich ein
                solches Land außerhalb Ihres Wohnsitzes befindet, stimmen Sie
                der Übertragung Ihrer personenbezogenen Daten in ein solches
                Land zu, um Ihnen die Plattform zur Verfügung zu stellen, auch
                wenn ein solches Land weniger Schutz für personenbezogene Daten
                bietet als das Land, in dem Sie wohnen. Wir stellen sicher, dass
                Sicherheitsvorkehrungen getroffen werden, die mit unseren
                Verpflichtungen zur Wahrung der Sicherheit Ihrer
                personenbezogenen Daten gemäß den Gesetzen Ihres Wohnsitzes
                übereinstimmen.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Vorratsspeicherung</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                Wir bewahren Ihre personenbezogenen Daten so lange auf, wie Sie
                ein Konto auf der Plattform unterhalten. Wir hören auf, Ihre
                personenbezogenen Daten aufzubewahren, oder entfernen die
                Mittel, mit denen die personenbezogenen Daten mit bestimmten
                Personen in Verbindung gebracht werden können, sobald es
                vernünftig ist, anzunehmen, dass -
            </p>
            <p style={{ marginBottom: '0in' }}>
                (a) der Zweck, für den diese personenbezogenen Daten erhoben
                wurden, durch die Aufbewahrung nicht mehr erfüllt wird; und
            </p>
            <p style={{ marginBottom: '0in' }}>
                (b) die Aufbewahrung aus rechtlichen, buchhalterischen oder
                geschäftlichen Gründen nicht mehr erforderlich ist.
            </p>
            <p style={{ marginBottom: '0in' }}>
                Bitte beachten Sie, dass bestimmte Gesetze uns dazu verpflichten
                können, Konten für einen bestimmten Zeitraum aufzubewahren.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Links von Drittanbietern</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                Unsere Plattform kann Links zu Websites Dritter enthalten. Der
                Zugriff auf und die Nutzung von solchen verlinkten Websites
                unterliegt nicht dieser Richtlinie, sondern den
                Datenschutzrichtlinien dieser Websites Dritter. Wir sind nicht
                verantwortlich für die Informationspraktiken solcher Websites
                Dritter.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Kinder unter 18 Jahren</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                Unsere Plattform ist nicht für Kinder unter 18 Jahren gedacht.
                Wenn wir feststellen, dass ein Kind unter 18 Jahren uns
                personenbezogene Daten zur Verfügung gestellt hat, werden wir
                diese Daten aus unseren Systemen löschen.
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Änderungen an unserer Datenschutzpolitik</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                Diese Richtlinie ist ab dem oben angegebenen Datum des
                Inkrafttretens gültig. Wir können diese Richtlinie von Zeit zu
                Zeit ändern, daher sollten Sie sie regelmäßig überprüfen. Wir
                werden alle Änderungen an dieser Richtlinie auf der Plattform
                veröffentlichen. Wenn wir Änderungen an dieser Richtlinie
                vornehmen, die sich wesentlich auf unsere Praktiken in Bezug auf
                die personenbezogenen Daten auswirken, die wir zuvor von Ihnen
                erfasst haben, werden wir uns bemühen, Sie im Voraus über eine
                solche Änderung zu informieren, indem wir die Änderung auf
                unserer Plattform hervorheben oder eine Push-Benachrichtigung
                über die Website bereitstellen (Sie sollten sicherstellen, dass
                Ihre Website-Einstellungen solche Push-Benachrichtigungen
                zulassen) oder eine E-Mail senden, die Sie in Ihrem Konto
                angegeben haben (aus diesem Grund sollten Sie sicherstellen,
                dass Sie Ihre Kontoinformationen umgehend aktualisieren, wenn
                sie sich ändern).
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
            <p style={{ marginBottom: '0in' }}>
                <b>Wie Sie uns kontaktieren können</b>
            </p>
            <p style={{ marginBottom: '0in' }}>
                Wenn Sie Fragen zur Datenschutzpolitik von SafeTravy haben, zu
                den Daten, die wir über Sie speichern, oder wenn Sie eines Ihrer
                Datenschutzrechte ausüben möchten, zögern Sie bitte nicht, uns
                zu kontaktieren
            </p>
            <p style={{ marginBottom: '0in' }}>
                <span style={{ fontSize: '11pt' }}>per E-Mail </span>
                <a href='mailto:safetravy@gmail.com'>
                    <span style={{ fontSize: '11pt', color: '#1155cc' }}>
                        <u>support@safetravy.com</u>
                    </span>
                </a>
            </p>
            <p style={{ marginBottom: '0in' }}>
                <br />
            </p>
        </>
    )
}
